//This app name will be used to determine the origin of the user in the legal disclaimer
export const APP_NAME_LEGAL_DISCLAIMER = "OutOfServiceRecovery";
export const APP_NAME_APPINSIGHTS = "OutOfServiceRecoveryUI";
//Regex pattern of allowed characters for problem text and location fields
export const PROBLEMTEXT_LOCATION_REGEX_PATTERN = /^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{}|\\,.<>/?:]*$/;
export const PROBLEMTEXT_LOCATION_REGEX_REPLACE = /[^a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{}|\\,.<>/?:]/g;